import React from 'react';
import { Box } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Timestamp } from 'firebase/firestore';
import { toSafeDate } from '../../utils/appDateFunctions';

interface TimeFieldProps {
  value: Timestamp | null;
  onChange: (value: Timestamp | null) => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

const TimeField: React.FC<TimeFieldProps> = ({ value, onChange, autoFocus, disabled }) => {
  const dateValue = toSafeDate(value);

  const handleChange = (newValue: Date | null) => {
    if (newValue && !isNaN(newValue.getTime())) {
      onChange(Timestamp.fromDate(newValue));
    } else {
      onChange(null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <TimePicker
          value={dateValue}
          onChange={handleChange}
          autoFocus={autoFocus}
          disabled={disabled}
          slotProps={{
            textField: {
              variant: 'standard',
              sx: {
                minWidth: 160,
                '& .MuiInput-root': {
                  fontSize: '1.25rem',
                },
                '& .MuiInput-input': {
                  textAlign: 'center',
                  py: 1,
                },
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default TimeField;
